import React from "react";
import KamAssignment from "./KamAssignment";
import { useKamAssignment } from "../hooks/candidate/useKamAssignment";
import { getCurrentUser } from "../utils/auth";

interface ApplicationKamAssignmentProps {
  applicationId: number;
}

const ApplicationKamAssignment: React.FC<ApplicationKamAssignmentProps> = ({
  applicationId,
}) => {
  const user = getCurrentUser();
  const hook = useKamAssignment({
    candidateId: applicationId,
    userRole: user?.role || "",
    enabled: !!applicationId,
  });

  return <KamAssignment hook={hook} />;
};

export default ApplicationKamAssignment;
